module.exports = __webpack_public_path__ + "static/media/400418_01.8476182b.png";